import React, { useEffect, useCallback, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";
import DefMembershipActions from "../../Redux/actions/defMembership-actions";
import Import from "./import";
import { CreateAudienceDialog } from "./CreateAudienceDialog";
import "../../Styles/pages/customers.scss";
import "../../Styles/pages/dashboard.scss";

const Audiences = () => {
    const { t } = useTranslation("common");
    const navigate = useNavigate();

    const [createAudienceVisible, setCreateAudienceVisible] = useState(false);

    const defMembership = useSelector((state) => state.defMembership.defMembership);

    const dispatch = useDispatch();
    const getMembership = useCallback(() => dispatch(DefMembershipActions.defMembershipRequest()), [dispatch]);

    const isAdminOrOwner = defMembership?.role === "OWNER" || defMembership?.role === "ADMIN";

    useEffect(() => {
        if (!defMembership) {
            getMembership();
        }
    }, [defMembership, getMembership]);

    useEffect(() => {
        if (defMembership && !isAdminOrOwner) {
            navigate("/crm/customers", { replace: true });
        }
    }, [defMembership, isAdminOrOwner, navigate]);

    const handleAudienceCreated = (createdAudience) => {
        if (createdAudience?.id) {
            navigate(`/crm/audiences/audience/${createdAudience.id}`, { state: { audience: createdAudience } });
        }
    };

    if (!defMembership || !isAdminOrOwner) {
        return null;
    }

    return (
        <div className="customerContent audiences-screen">
            <div className="main-container subscribers-page-header audiences-page-header">
                <div className="subscribers-page-actions">
                    <Button
                        className="segment_button import_button"
                        label={t("business_customers.create_audience")}
                        onClick={() => setCreateAudienceVisible(true)}
                    />
                </div>
            </div>

            <CreateAudienceDialog
                visible={createAudienceVisible}
                onHide={() => setCreateAudienceVisible(false)}
                businessId={defMembership?.business?.id}
                onCreated={handleAudienceCreated}
            />

            <Import />
        </div>
    );
};

export default Audiences;
